import React from 'react';
import PropTypes from 'prop-types';

import OEResizeObserver from '../../../lib/components/oe-resize-observer';
import NotificationCenter from '../../../lib/notification/notification-center';
import OEEventHelper from '../../../lib/tools/oe-event-helper';
import {OEMediaViewerReadyState, OEMediaViewerContentSizeMode} from '../oe-media-viewer-model';
import OEMediaViewerContentController from './oe-media-viewer-content-controller';

export default class OEMediaViewerHtmlContentController extends React.PureComponent {

    constructor(props) {
        super(props);

        this.unitSize = 16;

        this.readyState = OEMediaViewerReadyState.noMeta;
        this.progress = 0;
        
        this.onIFrameProgress = this.onIFrameProgress.bind(this);
        this.onIFrameGoToItem = this.onIFrameGoToItem.bind(this);
        this.onIFrameShowMedia = this.onIFrameShowMedia.bind(this);

        this.onLoad = this.onLoad.bind(this);
        this.onError = this.onError.bind(this);

        this.onUnitSizeResize = this.onUnitSizeResize.bind(this);
        this.onIFrameRef = this.onIFrameRef.bind(this);
    }

    getReadyState() {
        // since there are diverse problems (also browser specific) with obtaining loading state (onLoad, onError) we are pulling back to static readyState 'ready' for now
        return OEMediaViewerReadyState.ready; //this.readyState;
    }
    
    getContentSize()    {
        return {mode: OEMediaViewerContentSizeMode.fill};
    }

    getProgress()   {
        return this.progress;
    }

    setProgress(progress)   {
        if(this.progress != progress) {
            this.progress = progress;
            if(this.props.onProgressChanged)    this.props.onProgressChanged(progress);
        }
    }

    componentWillReceiveProps(nextProps) {
        /*
        if(nextProps.src !== this.props.src)     {
            if(this.readyState !== OEMediaViewerReadyState.noMeta) {
                this.readyState = OEMediaViewerReadyState.noMeta;
                if(this.props.onReadyStateChanged)  this.props.onReadyStateChanged(this.readyState);
            }
        }
        */
    }

    applyProgress() {
    }

    updateIFrameBodyFontSize()  {
        if(!this.$iFrameDocumentBody)   return;
        this.$iFrameDocumentBody.css({'fontSize': this.unitSize.toString() + 'px'});
    }

    onIFrameProgress(message, userInfo)  {
        let progress = userInfo[message];
        //console.log('onIFrameProgress - ' + progress.toString());
    }

    onIFrameGoToItem(message, userInfo)  {
        let name = userInfo[message];
        //console.log('onIFrameGoToItem - ' + name);
        if(this.props.onGoToItem)   this.props.onGoToItem(name);
    }

    onIFrameShowMedia(message, userInfo)  {
        let path = userInfo[message];
        //console.log('onIFrameShowMedia - ' + path);
        if(this.props.onShowMedia)  this.props.onShowMedia(path);
    }

    onLoad(e)    {
        //console.log('onLoad');

        if(!this.iFrameRef || !this.iFrameRef.contentWindow)    return;
        this.iFrameDocument = this.iFrameRef.contentWindow.document;
        this.$iFrameDocumentBody = $(this.iFrameDocument.documentElement).find('body');
        this.updateIFrameBodyFontSize();

        /*
        if(this.readyState !== OEMediaViewerReadyState.ready)    {
            this.readyState = OEMediaViewerReadyState.ready;
            if(this.props.onReadyStateChanged)  this.props.onReadyStateChanged(this.readyState);
        }
        */
    }

    onError(e)    {
        //console.log('onError');
        /*
        if(this.readyState !== OEMediaViewerReadyState.error) {
            this.readyState = OEMediaViewerReadyState.error;
            if(this.props.onReadyStateChanged)  this.props.onReadyStateChanged(this.readyState);
        }
        */
    }

    onUnitSizeResize(sender, size)  {
        if(this.unitSize === size.w) return;
        this.unitSize = size.w;
        this.updateIFrameBodyFontSize();
    }
    
    onIFrameRef(ref) {
        if(this.iFrameRef === ref)    return;

        if(this.iFrameRef)    this.iFrameRef.contentWindow.oeNotificationCenter = null;

        if(this.iFrameDocument) {
            this.iFrameDocument = null;
            this.$iFrameDocumentBody = null;
        }

        this.iFrameRef = ref;

        OEEventHelper.bubbleIframeEvents(this.iFrameRef);

        if(this.iFrameRef)    {
            let center = new NotificationCenter();
            this.iFrameRef.contentWindow.oeNotificationCenter = center;
            center.register('progress', this.onIFrameProgress);
            center.register('goToItem', this.onIFrameGoToItem);
            center.register('showMedia', this.onIFrameShowMedia);
        }
    }

    render() {
        return (
            <OEMediaViewerContentController
                className={this.props.className}
                backgroundColor={this.props.backgroundColor}
                contentRect={this.props.contentRect}
            >
                <OEResizeObserver className="unit-size-observer" onResize={this.onUnitSizeResize}/>

                <iframe
                    src={this.props.src}
                    onLoad={this.onLoad}
                    onError={this.onError}
                    ref={this.onIFrameRef}
                />
            </OEMediaViewerContentController>
        );
    }
}

OEMediaViewerHtmlContentController.defaultProps = {
    className: ''
};

OEMediaViewerHtmlContentController.propTypes = {
    className: PropTypes.string,
    onProgressChanged: PropTypes.func,
    onGoToItem: PropTypes.func,
    onShowMedia: PropTypes.func,
    onReadyStateChanged: PropTypes.func
};